import { DomSanitizer } from "@angular/platform-browser";
import { Message, MessagePart } from "../models/message";
import { Injectable } from "@angular/core";

@Injectable()
export class ChatUtils {

  constructor(private sanitizer: DomSanitizer) { }

  public visualizeMessage(message: Message): void {
    const text = message.text || "";
    const parts: MessagePart[] = [];
    // Never interpret user text as HTML, including text surrounding a media URL.
    const urls = /https?:\/\/[^\s<>"'`]+/gi;
    let start = 0;
    let match: RegExpExecArray;
    while ((match = urls.exec(text)) !== null) {
      if (match.index > start) parts.push({kind: "text", text: text.slice(start, match.index)});
      parts.push(this.mediaPart(match[0]) || {kind: "text", text: match[0]});
      start = match.index + match[0].length;
    }
    if (start < text.length) parts.push({kind: "text", text: text.slice(start)});
    message.parts = parts;
  }

  private mediaPart(value: string): MessagePart | null {
    try {
      const url = new URL(value);
      if (!["https:", "http:"].includes(url.protocol) || url.username || url.password) return null;
      const videoId = this.youtubeVideoId(url);
      if (videoId) {
        // Only a fixed origin/path plus a validated ID may bypass resource URL checks.
        return {kind: "youtube", embedUrl: this.sanitizer.bypassSecurityTrustResourceUrl(
          "https://www.youtube.com/embed/" + videoId)};
      }
      if (/\.(png|jpe?g|gif|svg)$/i.test(url.pathname)) return {kind: "image", url: url.href};
      if (/\.(mp4|ogg)$/i.test(url.pathname)) return {kind: "video", url: url.href};
    } catch {
      // Malformed URLs remain readable text instead of breaking the conversation.
    }
    return null;
  }

  private youtubeVideoId(url: URL): string | null {
    if (url.port) return null;
    let id: string = null;
    if (url.hostname === "youtu.be") {
      id = url.pathname.slice(1);
    } else if (["youtube.com", "www.youtube.com", "m.youtube.com"].includes(url.hostname)) {
      if (url.pathname === "/watch") id = url.searchParams.get("v");
      else id = url.pathname.match(/^\/(?:embed|shorts|v)\/([^/]+)$/)?.[1];
    }
    return id && /^[A-Za-z0-9_-]{11}$/.test(id) ? id : null;
  }
}
